import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import M from 'materialize-css/dist/js/materialize';
import { translate, formatData, getUserNameToName, downloadFile, enumText } from '../../../../utils/util';
import { Input, BackButton, Title, Button, InfiniteScroll, Collapsible } from '../../../../components/UI/ComponentsUI';
import { onValueChange } from '../../../../utils/handleChangeHooks';
import * as actionsStock from '../../../../actions/stockAction';
import StockService from '../../../../services/StockService';
import { isNullOrEmpty } from '../../../../utils/util';
import { ENUMS } from '../../../../utils/constants';

const Log = (props) => {
    const quality = props.history?.location?.state?.quality;
    const [currentPage, setCurrentPage] = useState(0);
    const [filter, setFilter] = useState(
        {
            inicialDate: "",
            finalDate: "",
            area: "",
            partNumber: "",
            barCode: "",
            operation: quality ? ENUMS.eStockOperation.Quality.value : null
        });
    const [logs, setLogs] = useState([]);
    const [instanceM, setInstanceM] = useState();

    useEffect(() => {
        if (props.logs?.items?.length > 0) {
            if (logs.length > 0 && currentPage === 0) {
                setLogs([...props.logs.items]);
            } else {
                setLogs((prevState) => ([...prevState, ...props.logs.items]));
            }
        } else {
            setLogs([]);
        }
        // eslint-disable-next-line
    }, [props?.logs?.items]);

    const getLogFilter = (click) => {
        var currentPageList = click ? 0 : currentPage;
        if (click) {
            setCurrentPage(0);
        }
        props.getLogs(Object.assign(filter, {
            PageSize: 25,
            PageIndex: currentPageList
        }), () => {
            if (instanceM) {
                instanceM[1].close();
            }
        });
    }

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    useEffect(() => {
        const instance = M.Collapsible.init(document.querySelectorAll('.collapsible'), {
            accordion: false
        });
        setInstanceM(instance);
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (currentPage > 0) {
            getLogFilter(false);
        }
        // eslint-disable-next-line
    }, [currentPage]);

    const onSelectChange = (item) => {
        props.selectLog(item);
        props.history.push({
            pathname: `./log/details`
        });
    }

    const getReport = () => {
        props.getReport(filter, (response) => {
            downloadFile(response, `${quality ? translate('delivery:report') : translate('logs', 'stock')}.xlsx`, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", true);
            if (instanceM) {
                instanceM[1].close();
            }
        });
    }

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <Title icon="mdi mdi-clipboard-list-outline" label={quality ? translate('delivery:report') : translate('logs', 'stock')} />
            </div>
            <div className="container-fluid" style={{ marginTop: '20px' }}>
                <div className="container" style={{ marginTop: '0px', }}>
                    <Collapsible
                        id="collapsible"
                        header={translate('filter', 'physical-confirmation')}
                        body={
                            <form id="getLogs" className="col s12">
                                <div className="row" style={{ padding: '10px' }}>
                                    <div className="input-field col s6 no-padding m6">
                                        <Input
                                            defaultValue={filter.inicialDate}
                                            type="date"
                                            label={translate('date-start', 'truck-kanban')}
                                            id="inicialDate"
                                            name="inicialDate"
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field col s5 no-padding m5">
                                        <Input
                                            defaultValue={filter.finalDate}
                                            type="date"
                                            label={translate('date-end', 'truck-kanban')}
                                            id="finalDate"
                                            name="finalDate"
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field col s6 no-padding m6">
                                        <Input
                                            label={translate('stock:area')}
                                            id="area"
                                            name="area"
                                            type="text"
                                            onChange={onChange}
                                            defaultValue={filter?.area}
                                        />
                                    </div>
                                    <div className="input-field col s5 no-padding m5">
                                        <Input
                                            label={translate('stock:cim')}
                                            id="barCode"
                                            name="barCode"
                                            type="text"
                                            maxLength={10}
                                            onChange={onChange}
                                            defaultValue={filter?.barCode}
                                        />
                                    </div>
                                    <div className="input-field col s11 no-padding" >
                                        <Input
                                            label={translate('stock:partnumber')}
                                            id="partNumber"
                                            name="partNumber"
                                            type="text"
                                            onChange={onChange}
                                            defaultValue={filter?.partNumber}
                                        />
                                    </div>
                                </div>
                            </form>
                        }
                    />
                    <div className="row" style={{ paddingTop: '5px' }}>
                        <Button full="true" text={translate('stock:search')} onClick={() => getLogFilter(true)} />
                    </div>
                    {
                        logs.length > 0 &&
                        <div className="row" style={{ paddingTop: '1px' }}>
                            <Button full="true" text="Download" onClick={getReport} />
                        </div>
                    }
                </div>
                <div id="loglist">
                    <InfiniteScroll
                        page={props.logs?.totalPages}
                        current={{ currentPage, setCurrentPage }}
                        hasMore={currentPage < props.logs?.totalPages}
                        data={logs.map((item) => (
                            <div
                                className="row"
                                style={{ display: 'block', marginBottom: '0px', marginLeft: '0px' }}
                                onClick={() => {
                                    onSelectChange(item);
                                }}
                            >
                                {
                                    !isNullOrEmpty(item.area) &&
                                    <span className="title sixth-text-color" style={{ display: 'block' }} >
                                        {item.area}
                                    </span>
                                }
                                {
                                    !isNullOrEmpty(item.partNumber) &&
                                    <span className="title sixth-text-color" style={{ display: 'block' }} >
                                        {item.partNumber}
                                    </span>
                                }
                                {
                                    !isNullOrEmpty(item.barCode) &&
                                    <span className="title sixth-text-color" style={{ display: 'block' }} >
                                        {item.barCode}
                                    </span>
                                }
                                <span className="title sixth-text-color" style={{ display: 'block' }} >
                                    {item.quantity}
                                </span>
                                {
                                    !isNullOrEmpty(item.operation) && item.operation !== 1 &&
                                    <span className="title sixth-text-color" style={{ display: 'block' }} >
                                        {translate(enumText(ENUMS.eStockOperation, item.operation || ''))}
                                    </span>
                                }
                                {
                                    !isNullOrEmpty(item.orderCode) &&
                                    <span className="title sixth-text-color" style={{ display: 'block' }} >
                                        {item.orderCode}
                                    </span>
                                }
                                {item.multiple === true &&
                                    <span className="title sixth-text-color" style={{ display: 'block' }} >
                                        {translate('stock:multiple')}
                                    </span>
                                }
                                <span className="truncate second-text-color" style={{ display: 'block', paddingLeft: '10px' }} >
                                    {getUserNameToName(props.usersFromElog, item?.createdBy)}
                                </span>
                                {
                                    !item?.success ?
                                        <div className="col s12 second-text-color"  >
                                            {translate('line-picking:transmission.erro-send')} - {formatData(item.createdOn)}
                                        </div>
                                        : <div className="col s12 second-text-color"  >
                                            {translate('line-picking:transmission.send')} - {formatData(item?.createdOn || '')}
                                        </div>
                                }
                            </div>
                        ))}
                    />
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        logs: state.stockReducer.logs
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getLogs: (filter, callback) => {
            dispatch(StockService.getLogsPaged(filter, callback));
        },
        getReport: (filter, callback) => {
            dispatch(StockService.getReport(filter, callback));
        },
        selectLog: (item) => {
            dispatch(actionsStock.selectLog(item));
        },
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Log)));
